const Mensagens = {
  APLICACAO_INDISPONIVEL: 'Aplicação indisponível!',
  USUARIO_SENHA_INVALIDOS: 'Usuário ou senha inválidos',
  ERRO_INTERNO: 'Ocorreu um erro interno do servidor!',
  ACESSO_NEGADO: 'Ação não permitida. Seu perfil não possui acesso a essa funcionalidade.',
  USUARIO_NAO_POSSUI_PERFIL: 'Usuário não possui perfil atribuido para esta aplicação!',
  SERVICO_TEMPORARIAMENTE_INDISPONIVEL: 'Serviço temporariamente indisponível!',
  REGISTRO_SALVO_SUCESSO: 'Registro salvo com sucesso!',
  ERRO_AO_EXECUTAR: 'Erro ao executar ação: ',
  TAMANHO_MAXIMO_CAMPO_VALOR: 'O tamanho máximo para cada item do campo valor, deve ser menor ou igual a 100. \n' +
  ' Verifique o valor : ',
  IDENTIFICADOR_INVALIDO: 'Identificador inválido.',
  ERRO_CARREGAR_TELA: 'Erro ao tentar carregar a tela.',
  ERRO_PESQUISA: 'Erro ao tentar efetuar a pesquisa.',
  ERRO_VALIDACAO: 'Erro durante o processo de validação/recusa.',
  SUCESSO_VALIDACAO: 'Validação/Recusa efetuado com sucesso!',
  ERRO_USUARIO_CADASTRO_NAO_PODE_VALIDAR: 'Usuário que inseriu o parâmetro não tem permissão para validar ou recusar o mesmo.',
  ERRO_VALIDACAO_FORMULARIO: 'Ops, algo deu errado, verifique o formulário e tente novamente!'
}

export default Object.freeze(Mensagens)
